module.exports = __webpack_public_path__ + "media/images/icons/filled/backward-3f52fe839981a1adf12a718b25d4d854.svg";